import React from 'react';
import { MOBILE_COLORS, MOBILE_BORDERS, MOBILE_SPACING, MOBILE_ANIMATIONS } from '../../styles/mobileTheme';

const MobileCard = ({
  children,
  variant = 'default', // default, elevated, outlined, glass
  padding = 'md',
  onClick,
  style = {},
  ...props
}) => {
  const getVariantStyles = () => {
    switch (variant) {
      case 'elevated':
        return {
          backgroundColor: MOBILE_COLORS.card,
          border: 'none',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.4)',
        };
      case 'outlined':
        return {
          backgroundColor: 'transparent',
          border: `1px solid ${MOBILE_COLORS.border}`,
        };
      case 'glass':
        return {
          backgroundColor: 'rgba(30, 35, 41, 0.8)',
          backdropFilter: 'blur(10px)',
          border: `1px solid ${MOBILE_COLORS.border}`,
        };
      case 'default':
      default:
        return {
          backgroundColor: MOBILE_COLORS.card,
          border: `1px solid ${MOBILE_COLORS.border}`,
        };
    }
  };

  const getPaddingValue = () => {
    switch (padding) {
      case 'none': return '0';
      case 'sm': return MOBILE_SPACING.sm;
      case 'lg': return MOBILE_SPACING.xl;
      case 'md':
      default: return MOBILE_SPACING.lg;
    }
  };

  const baseStyles = {
    borderRadius: MOBILE_BORDERS.radius.lg,
    padding: getPaddingValue(),
    transition: MOBILE_ANIMATIONS.fast,
    cursor: onClick ? 'pointer' : 'default',
    ...getVariantStyles(),
    ...style,
  };

  return (
    <div
      style={baseStyles}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
};

export default MobileCard;
